import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "./app/providers";
import { loadSupportChat } from "./app/support-chat";
import { hasSsoSession } from "./auth/auth-token";
import { initI18n } from "./locales/config";
import "./styles.css";

async function boot() {
  const rootElement = document.getElementById("root");

  if (!rootElement) {
    throw new Error("BlyCare Admin root element is missing");
  }

  // Keep this build-time constant inline so non-mock builds never emit the MSW chunk.
  if (__BLYCARE_MOCK_MODE__) {
    const { enableMockMode } = await import("./mocks/enable");
    await enableMockMode();
  }

  // 本地开发与 SSO 直达都没有 Shopify 宿主，需要同一套外壳。
  if (__BLYCARE_LOCAL_MODE__ || hasSsoSession()) {
    const { installDevAdminHost } = await import("./app/dev-admin-host");
    installDevAdminHost();
  }

  // 客服脚本在部署环境加载，本地和 SSO 直达不加载。
  if (!__BLYCARE_LOCAL_MODE__ && !hasSsoSession()) {
    loadSupportChat();
  }

  await initI18n();

  createRoot(rootElement).render(
    <StrictMode>
      <AppProviders />
    </StrictMode>,
  );
}

void boot();
